// extracted by mini-css-extract-plugin
module.exports = {"bg":"e_W3","border":"e_X3"};